import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[disableScroll]'
})

export class DisableScrollDirective {

  constructor() {}

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    (event.target as HTMLElement).blur();
  }
}